import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { SearchPlaceIcon } from 'src/components/insights/icons/search-place'
import { Colors } from 'src/components/theme'
import { isFeatureEnabled } from 'src/utils/feature-flag'
import { useRouter } from 'next/router'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'

const BrandProfileContent = dynamic(() => import('src/components/insights/brand-profile/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const BrandProfilePage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  const isEnabled = isFeatureEnabled('brand-profile')
  const router = useRouter()

  useEffect(() => {
    if (!isEnabled) {
      void router.push('/')
    }
  }, [router, isEnabled])

  return (
    <InsightContainer insight={insight} color={Colors.purpleDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        <BrandProfileContent insight={insight} />
      </React.Suspense>
    </InsightContainer>
  )
}

export const BrandProfile: Insight = {
  id: 'brand-profile',
  component: BrandProfilePage,
  name: 'Brand Profile',
  icon: SearchPlaceIcon,
  supportedResultTypes: ['alphamap-location'],
  linkTooltipFile: 'insights-brand-profile',
}
